import styled from "styled-components";
import React, { useState } from "react";

const HeaderWrapper = styled.div`
  font-family: Menu;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
  // padding-right: 3rem;
  padding-top: 2rem;
  padding-bottom: 1rem;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1;
  background-color: black;

  @media only screen and (max-width: 768px) {
    overflow: hidden;
    justify-content: center;
    //padding: 1rem;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    height: 2px;
    width: 25px;
    background: white;
    margin-bottom: 4px;
  }

  @media (max-width: 768px) {
    display: flex;
    padding-right: 2rem;
    padding-bottom: 1rem;
  }
`;

const Menu = styled.div<{ isOpen: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    overflow: hidden;
    flex-direction: column;
    flex-grow: 1;
    max-height: ${({ isOpen }) => (isOpen ? "300px" : "0px")};
    transition: max-height 0.3s ease-in;
    text-align: center;
  } ;
`;

const Link = styled.a`
  margin: 0 1rem;
  // text-decoration: lightpink wavy underline;
  // text-decoration-thickness: 2px;
  text-decoration: none;
  transition: color 1s;
  font-size: 1.2rem;
  color: white;
  text-align: center;
  padding-left: 2.7rem;

  :hover {
    font-family: Hover;
    text-decoration-thickness: 4px;
  }
  :visited {
  }
`;

// 💻 HOME
// 👀 ABOUT
// ✨ NFTS
// 💕 INSTA
// 🔮 TWITCH
// 🌸 TIKTOK

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HeaderWrapper>
      <Menu isOpen={isOpen}>
        <Link href="/">WORK</Link>
        <Link href="/about">ABOUT</Link>
        <Link href="/nft">NFTS </Link>
        <Link
          href="https://www.instagram.com/brunaaart"
          target="_blank"
          rel="noopener noreferrer"
        >
          INSTAGRAM
        </Link>
        <Link
          href="https://www.twitch.tv/brunaaart"
          target="_blank"
          rel="noopener noreferrer"
        >
          TWITTER
        </Link>
        <Link
          href="https://twitter.com/bruna_a_v"
          target="_blank"
          rel="noopener noreferrer"
        >
          TIKTOK
        </Link>
      </Menu>
      <Hamburger onClick={() => setIsOpen(!isOpen)}>
        <span />
        <span />
        <span />
      </Hamburger>
    </HeaderWrapper>
  );
};

export default Header;
